"use client";

import { useEffect } from "react";

export function ServiceWorkerRegister() {
  useEffect(() => {
    // `import.meta.env.PROD` is Vite's build-time constant, replacing `NODE_ENV`. Same intent:
    // a service worker in development caches the very assets HMR is trying to replace.
    if (!import.meta.env.PROD) return;
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js");
  }, []);

  return null;
}
